import { Button, I18nProvider as HeroI18nProvider } from "@heroui/react";
import { i18n, intlLocales, supportedLocales, type SupportedLocale } from "@hallyulytics/i18n";
import { I18nProvider as LinguiProvider } from "@lingui/react";
import type { ReactNode } from "react";

export interface AppFrameProps {
  readonly application: string;
  readonly locale: SupportedLocale;
  readonly children: ReactNode;
}

export function AppFrame({ application, locale, children }: AppFrameProps) {
  return (
    <LinguiProvider i18n={i18n}>
      <HeroI18nProvider locale={intlLocales[locale]}>
        <div className="app-frame">
          <header className="app-header">
            <a className="brand" href="/" aria-label={`${application} home`}>
              HallyuLytics <span>{application}</span>
            </a>
            <nav aria-label="Utilities">
              <label className="locale-control">
                <span className="sr-only">Language</span>
                <select
                  value={locale}
                  onChange={(event) => {
                    document.cookie = `hl_locale=${event.target.value}; Path=/; Max-Age=31536000; Secure; SameSite=Lax`;
                    location.reload();
                  }}
                >
                  {supportedLocales.map((item) => (
                    <option key={item} value={item}>
                      {item.replace("_", "-")}
                    </option>
                  ))}
                </select>
              </label>
              <Button
                variant="secondary"
                onPress={() => document.documentElement.classList.toggle("dark")}
              >
                Theme
              </Button>
            </nav>
          </header>
          {children}
        </div>
      </HeroI18nProvider>
    </LinguiProvider>
  );
}
